import React, { PureComponent, ReactNode } from "react";
import { Row, Col } from "react-bootstrap";
import "./Article.scss";
import HelpContacts from "../../components/Article/Sidebar/HelpContacts";
import NeedHelp from "../../components/NeedHelp";
import { IArticle, Articles } from "../../StrapiService";
import SanitizeHTML from "../../components/SanitizeHTML";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

/**
 *
 *
 *    FIX LATER with strapi updates fields with ts-ignore!!!
 *    BUG ON STRAPI, instead of returning an array of items on getEntries, it returns one object if only one entry exists
 *
 *
 */

interface Props {
    locale: string;
    t: TFunction;
}
interface State {
    aboutArticle?: Partial<IArticle>[];
    articles: IArticle[];
    locale?: string;
}
class AboutPC extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            aboutArticle: undefined,
            articles: [],
            locale: undefined,
        };
    }
    async update() {
        if (this.state.locale !== this.props.locale) {
            await this.setState({
                aboutArticle: await Articles.getAboutArticle(this.props.locale),
                articles: await Articles.getLatestArticles(3),
                locale: this.props.locale,
            });
        }
    }
    /* async componentDidMount() {
    await this.setState({
      aboutArticle: await Articles.getAboutArticle(this.props.locale),
      articles: await Articles.getLatestArticles(3)
    })
  } */
    componentDidMount() {
        this.update();
    }
    componentDidUpdate(nextProps: Props) {
        this.update();
    }
    componentWillUnmount() {
        this.setState({});
    }
    render(): ReactNode {
        return (
            <>
                <div className="article-page aside-show d-flex">
                    <article>
                        <h1>{this.props.t("about.title")}</h1>
                        {!this.state.aboutArticle && <p>{this.props.t("loading.loadingPage")}</p>}
                        {
                            // @ts-ignore
                            this.state.aboutArticle && this.state.aboutArticle.content && (
                                <div>
                                    <SanitizeHTML
                                        html={
                                            // @ts-ignore
                                            this.state.aboutArticle.content?.text
                                        }
                                    />
                                </div>
                            )
                        }
                        <div className="more">
                            {this.state.articles.length > 0 && (
                                <>
                                    <h2>{this.props.t("home.announcements")}</h2>
                                    <Row>
                                        <Col sm="6" md="8">
                                            <div className="articles">
                                                <ul>
                                                    {this.state.articles.map((a, i) => (
                                                        <li key={`article-${i}`}>
                                                            <Link to={`/article/${a.slug}`}>{a.title}</Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Col>
                                        <Col sm="6" md="4">
                                            <div className="buttons">
                                                <Link to="/permits" className="btn btn-primary btn-block text-left mb-3">
                                                    {this.props.t("home.link.orderPermit")}
                                                </Link>
                                                <Link to="/public-info" className="btn btn-secondary btn-block text-left">
                                                    {this.props.t("home.link.publicInfo")}
                                                </Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    </article>
                    {
                        // @ts-ignore
                        this.state.aboutArticle && (this.state.aboutArticle as IArticle).contacts && (
                            <aside className="d-none d-sm-none d-md-none d-lg-block">
                                <HelpContacts
                                    contacts={
                                        // @ts-ignore
                                        this.state.aboutArticle.contacts
                                    }
                                    t={this.props.t}
                                />
                            </aside>
                        )
                    }
                </div>
                <div className="d-flex justify-content-center">
                    <div className="d-block d-sm-block d-lg-none mt-4 d-flex" style={{ maxWidth: "640px" }}>
                        <NeedHelp t={this.props.t} />
                    </div>
                </div>
            </>
        );
    }
}

export const About: React.FC<{}> = ({}) => {
    const { t, i18n } = useTranslation();

    return <AboutPC locale={i18n.language} t={t} />;
};

export default About;
